import { defineStore } from 'pinia';

import { useRootStore } from './root';

import {
  AggregationRepository,
  UnusedBalanceAggregationForm,
  UnusedBalanceAggregationResponse,
} from '@/repositories/generated';
import { CancelablePromise } from '@/repositories/generated/core/CancelablePromise';
import { UnusedBalanceAggregationUiFormSchema } from '@/validations';

type UnusedBalanceAggregationStoreState = {
  form?: UnusedBalanceAggregationForm;
  response?: UnusedBalanceAggregationResponse;
  promise?: CancelablePromise<UnusedBalanceAggregationResponse>;
};

export const useUnusedBalanceAggregationStore = defineStore('unusedBalanceAggregation', {
  state: (): UnusedBalanceAggregationStoreState => ({
    form: undefined,
    response: undefined,
  }),
  actions: {
    toRequestBody(form: UnusedBalanceAggregationUiFormSchema): UnusedBalanceAggregationForm {
      return {
        startDateTime: form.aggregationPeriod.startDateTime.toISOString(),
        endDateTime: form.aggregationPeriod.endDateTime.toISOString(),
        criteria: form.criteria,
        walletServiceIds: form.walletServices.map((value) => value.id),
      };
    },
    async generate(form: UnusedBalanceAggregationUiFormSchema) {
      const rootStore = useRootStore();
      rootStore.isLoading = true;

      this.form = this.toRequestBody(form);

      return AggregationRepository.register({ requestBody: this.form })
        .finally(() => {
          rootStore.isLoading = false;
        });
    },
    async aggregate(form: UnusedBalanceAggregationUiFormSchema) {
      this.form = this.toRequestBody(form);

      this.promise?.cancel();
      this.promise = AggregationRepository.unusedBalanceAggregation({ requestBody: this.form });
      this.response = await this.promise;
    },
  },
});
